export const CATEGORIES_ACTIONS = {
  INITIALIZE_CATEGORIES: 'INITIALIZE_CATEGORIES',
  UPDATE_SELECTED_CATEGORY: 'UPDATE_SELECTED_CATEGORY',
};
